// eslint-disable-next-line import/prefer-default-export
export const VoluntaryTimeOffType = Object.freeze({
    SingleDay: 0,
    BlockOfDays: 1,
    TimePeriod: 2,
});
